export function debounce(func, wait) {
    let timeout;
    return function (...args) {
        return new Promise((resolve, reject) => {
            const later = () => {
                timeout = null;
                try {
                    resolve(func.apply(this, args));
                } catch (error) {
                    reject(error);
                }
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        });
    };
}

export function removeHTMLTags(texto) {
    return texto.replace(/<\/?[^>]+(>|$)/g, "");
}

export function removeExtraSpaces(texto) {
    return texto.replace(/\s+/g, ' ').trim();
}


export function replaceHTMLTagsWithWhitespace(texto) {
    // Substituir todas as ocorrências de </div> por duas novas linhas (\n\n)
    texto = texto.replace(/<\/div>/gi, "\n");

    // Remover todas as outras tags HTML
    texto = texto.replace(/<[^>]+>/g, "");
    console.log(texto)

    return texto;
}
